import React, { useState, useEffect } from 'react';
import {
	Wrapper,
	Row,
	EmailWrapper,
	CompanyWrapper,
	RemoveWrapper,
	FormLabel,
	Actions,
	DropdownWrapper,
} from './AccessControl.styles';
import { Section } from 'Settings/Section';
import { TextInput } from 'Settings/TextInput';
import {
	ApButtonDanger,
	ApButtonMain,
	ApButtonSecondary,
	ApLoaderDefault,
	ApLoaderText,
	ApSimpleDropdown,
} from '@alixpartners/ui-components';
import { uniqueId } from 'lodash';
import {
	deleteFromAccessControl,
	getAccessControlInfo,
	getPCCompanies,
	saveAccessControl,
} from 'utils/apiRequests';
import { PermissionsContext } from 'contexts/PermissionsContext';
import { ApiDataContext } from 'contexts/ApiDataContext';
import { SpendCubeSettingsContext } from 'contexts/SpendCubeSettingsContext';
import { SettingsContext } from 'contexts/SettingsContext';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { UploadStateContext } from 'contexts/UploadStateContext';
import { ClassificationContext } from 'contexts/ClassificationContext';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import { isEqual } from 'lodash';
import { cloneDeep } from 'lodash';
import { ConfirmationDialog } from 'TaxonomyMapper/ConfirmationDialog';
import _ from 'lodash';
const getTitle = new Map([
	[8, 'Child Companies'],
	[11, 'Business Unit '],
	[31, 'Country'],
]);
const AccessControl = ({ companyId, refetchCompanies }) => {
	const [inputFields, setInputFields] = useState([]);
	const [companyOptions, setCompanyOptions] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isSaving, setIsSaving] = useState(false);
	const [accessControlCurrentData, setAccessControlCurrentData] = useState([]);
	const [
		isAccessControlRecordDeleteModalOpen,
		setisAccessControlRecordDeleteModalOpen,
	] = useState(false);
	const [currentIndextoBeDelete, setCurrentIndextoBeDelete] = useState(null);
	const [currentEmailtoBeDelete, setCurrentEmailtoBeDelete] = useState(null);

	useEffect(() => {
		setIsLoading(true);
		Promise.all([getAccessControlInfo(), getPCCompanies()])
			.then(([info, companies]) => {
				if (info.succeeded) {
					if (info.data.length > 0) {
						const accessInfo = info.data.map(el => {
							return {
								id: el.id,
								email: el.email,
								company: [{ label: el.companyName, value: el.companyName }],
							};
						});
						const currentAccessInfo = cloneDeep(accessInfo);
						setInputFields(accessInfo);
						setAccessControlCurrentData(currentAccessInfo);
					}
				}

				if (companies.succeeded) {
					let companiesList = [];
					let parentLegalEntity = [];
					let purchasingLegalEntity = [];
					if (Object.keys(companies.data).length > 0) {
						if (companies.data.parentLegalEntity.length > 0) {
							parentLegalEntity = companies.data.parentLegalEntity.map(x => {
								return { label: x, value: x, labelNode: <u>{x}</u> };
							});
						}
						if (companies.data.entity.length > 0) {
							purchasingLegalEntity = companies.data.entity.map(x => {
								return { label: x, value: x };
							});
						}
					}
					companiesList = [...parentLegalEntity, ...purchasingLegalEntity];
					setCompanyOptions(companiesList);
				}
				setIsLoading(false);
			})
			.catch(() => setIsLoading(false));
	}, []);
	const saveAccessControlInfo = () => {
		const changedObjects = _.differenceWith(
			inputFields,
			accessControlCurrentData,
			_.isEqual
		);

		const bodyParm = changedObjects.map(el => {
			const value = Object.values(el.company)[0];
			return {
				email: el.email,
				company: value.value || value,
			};
		});
		setIsSaving(true);
		saveAccessControl(bodyParm)
			.then(() => {
				setIsSaving(false);
				refetchCompanies();
			})
			.catch(() => setIsSaving(false));
	};

	const addInputField = () => {
		setInputFields([
			...inputFields,
			{
				uniqueID: uniqueId(),
				id: '',
				email: '',
				company: {},
			},
		]);
	};

	const handleEmailChange = (index, e) => {
		const { name, value } = e.target;
		const list = [...inputFields];
		list[index][name] = value;
		setInputFields(list);
	};

	const handleCompanyChange = (index, e) => {
		const list = [...inputFields];
		list[index]['company'] = e;
		setInputFields(list);
	};

	const removeInputFields = (index, email) => {
		const rows = [...inputFields];
		deleteFromAccessControl(email);
		rows.splice(index, 1);
		setInputFields(rows);
		const cloneRows = cloneDeep(rows);
		setAccessControlCurrentData(cloneRows);
	};
	const handleDeleteModal = (index, email) => {
		setCurrentIndextoBeDelete(index);
		setCurrentEmailtoBeDelete(email);
		setisAccessControlRecordDeleteModalOpen(state => !state);
	};
	const handleDeleteModalClose = () => {
		setCurrentIndextoBeDelete(null);
		setCurrentEmailtoBeDelete(null);
		setisAccessControlRecordDeleteModalOpen(state => !state);
	};
	const handleDeleteModalConfirm = () => {
		removeInputFields(currentIndextoBeDelete, currentEmailtoBeDelete);
		setCurrentIndextoBeDelete(null);
		setCurrentEmailtoBeDelete(null);
		setisAccessControlRecordDeleteModalOpen(state => !state);
	};

	return (
		<Section title="Access Control">
			{isLoading ? (
				<ApLoaderDefault loaderText={() => <ApLoaderText />} />
			) : (
				<>
					{isSaving ? (
						<ApLoaderDefault loaderText={() => <ApLoaderText />} />
					) : (
						<>
							<Wrapper>
								{inputFields?.map((item, index) => {
									const { email, company } = item;
									return (
										<Row key={index}>
											<EmailWrapper>
												<div>
													<TextInput
														name="email"
														label="Add Email"
														value={email}
														type="email"
														onChange={e => handleEmailChange(index, e)}
													/>
												</div>
											</EmailWrapper>
											<CompanyWrapper>
												<FormLabel>
													Select {`${getTitle.get(companyId) || ''}`}
												</FormLabel>
												<DropdownWrapper>
													<ApSimpleDropdown
														options={companyOptions}
														selected={company}
														style={{ width: '100%' }}
														onChange={e => handleCompanyChange(index, e)}
													/>
												</DropdownWrapper>
											</CompanyWrapper>
											<RemoveWrapper>
												<FormLabel>Remove</FormLabel>
												<div>
													<ApButtonDanger
														onClick={() => handleDeleteModal(index, email)}
														disabled={
															!isEqual(accessControlCurrentData, inputFields) ||
															_.some(inputFields, inputField =>
																_.isEmpty(_.trim(inputField.email))
															) ||
															_.some(inputFields, inputField =>
																_.isEmpty(inputField.company)
															)
														}
													>
														Remove
													</ApButtonDanger>
												</div>
											</RemoveWrapper>
										</Row>
									);
								})}
							</Wrapper>
							{console.log(
								_.some(
									inputFields,
									inputField =>
										_.isEmpty(_.trim(inputField.email)) &&
										_.isEmpty(_.trim(inputField.company[0]?.value))
								)
							)}
							<Actions>
								<ApButtonSecondary onClick={addInputField}>
									Add Row
								</ApButtonSecondary>
								{inputFields.length > 0 && (
									<ApButtonMain
										disabled={
											isEqual(accessControlCurrentData, inputFields) ||
											_.some(inputFields, inputField =>
												_.isEmpty(_.trim(inputField.email))
											) ||
											_.some(inputFields, inputField =>
												_.isEmpty(inputField.company)
											)
										}
										onClick={() => saveAccessControlInfo()}
									>
										Save
									</ApButtonMain>
								)}
							</Actions>
							{isAccessControlRecordDeleteModalOpen && (
								<ConfirmationDialog
									text={`Please Note, that Access Control for ${currentEmailtoBeDelete} will be Deleted!`}
									title="Access Control Delete"
									suppressCheckbox
									onConfirm={() => handleDeleteModalConfirm()}
									onClose={() => handleDeleteModalClose()}
								/>
							)}
						</>
					)}
				</>
			)}
		</Section>
	);
};

export default props => (
	<PermissionsContext.Consumer>
		{({ permissions }) => (
			<ApiDataContext.Consumer>
				{({ clearApiCache }) => (
					<SpendCubeSettingsContext.Consumer>
						{({ settings }) => (
							<SettingsContext.Consumer>
								{({
									companiesMetadata,
									opportunityYear,
									customFilters,
									hideDecimals,
									aliasName,
									companyName,
									appTitle,
									backgroundColor,
									foregroundColor,
									threshold1,
									threshold2,
									updateSettingsConfig,
									tailSpendAnalysisData,
									refetchCompanies,
								}) => (
									<QueryStringContext.Consumer>
										{({
											customFilters: selectedcustomFilters,
											customFiltersValues: selectedcustomFiltersValues,
											setQueryStringStateAndPush,
										}) => (
											<UploadStateContext.Consumer>
												{({ status, refetch }) => (
													<ClassificationContext.Consumer>
														{({ refetch: refetchClassification }) => (
															<SettingsOptionsContext.Consumer>
																{({ refetch: refetchSettingsOptions }) => (
																	<AccessControl
																		{...props}
																		companiesMetadata={companiesMetadata}
																		refetchClassification={
																			refetchClassification
																		}
																		refetchSettingsOptions={
																			refetchSettingsOptions
																		}
																		clearApiCache={clearApiCache}
																		opportunityYear={opportunityYear}
																		customFilters={customFilters}
																		hideDecimals={hideDecimals}
																		aliasName={aliasName}
																		companyName={companyName}
																		appTitle={appTitle}
																		backgroundColor={backgroundColor}
																		foregroundColor={foregroundColor}
																		threshold1={threshold1}
																		threshold2={threshold2}
																		updateSettingsConfig={updateSettingsConfig}
																		status={status}
																		fetchState={refetch}
																		setQueryStringStateAndPush={
																			setQueryStringStateAndPush
																		}
																		tailSpendAnalysisData={
																			tailSpendAnalysisData
																		}
																		selectedcustomFiltersValues={
																			selectedcustomFiltersValues
																				? Array.isArray(
																						selectedcustomFiltersValues
																				  )
																					? selectedcustomFiltersValues
																					: [selectedcustomFiltersValues]
																				: []
																		}
																		selectedcustomFilters={
																			selectedcustomFilters
																				? Array.isArray(selectedcustomFilters)
																					? selectedcustomFilters
																					: [selectedcustomFilters]
																				: []
																		}
																		permissions={permissions || []}
																		taxonomyVersion={settings.taxonomyVersion}
																		refetchCompanies={refetchCompanies}
																	/>
																)}
															</SettingsOptionsContext.Consumer>
														)}
													</ClassificationContext.Consumer>
												)}
											</UploadStateContext.Consumer>
										)}
									</QueryStringContext.Consumer>
								)}
							</SettingsContext.Consumer>
						)}
					</SpendCubeSettingsContext.Consumer>
				)}
			</ApiDataContext.Consumer>
		)}
	</PermissionsContext.Consumer>
);
